
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iVuad", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8kTwy = parcelRequire("8kTwy");




parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $h7YX1 = parcelRequire("h7YX1");


var $a6IPc = parcelRequire("a6IPc");


var $iNP4c = parcelRequire("iNP4c");


var $lAFHW = parcelRequire("lAFHW");


var $iJUOw = parcelRequire("iJUOw");


var $2v0M9 = parcelRequire("2v0M9");


var $aamGC = parcelRequire("aamGC");


var $0JTlo = parcelRequire("0JTlo");


var $hWVhC = parcelRequire("hWVhC");


var $1xVJk = parcelRequire("1xVJk");


var $mSdG9 = parcelRequire("mSdG9");


var $cgtv4 = parcelRequire("cgtv4");

const $233f78e62ed7ba05$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    confluenceAfterUpgradeAIStandardModalTitle: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.title",
        defaultMessage: "Welcome to Standard"
    },
    confluenceAfterUpgradeAIStandardModalSubtitle: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.subtitle",
        defaultMessage: "You successfully unlocked new ways to create, organize, and discover content with the help of AI"
    },
    confluenceAfterUpgradeAIStandardModalPrimaryCTA: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.primary-cta",
        defaultMessage: "Get started"
    },
    confluenceAfterUpgradeAIStandardModalSecondaryCTA: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.secondary-cta",
        defaultMessage: "Close"
    },
    confluenceAfterUpgradeAIStandardModalAIDraft: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.ai-draft",
        defaultMessage: "Ask AI to draft pages and improve writing"
    },
    confluenceAfterUpgradeAIStandardModalAISummaries: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.ai-summaries",
        defaultMessage: "Catch up on pages by generating a summary"
    },
    confluenceAfterUpgradeAIStandardModalAIContextualInfo: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.ai-contextual-info",
        defaultMessage: "Find contextual and reliable information with AI"
    }
});


const $1ac42967dc0afcbf$export$38ccae318ce089cf = ({ onInteractionComplete: onInteractionComplete })=>{
    const intl = (0, $8C5kA.default)();
    const { isOpen: isOpen, handleClose: handleClose } = (0, $0JTlo.useModalState)();
    const componentAttributes = {
        product: 'confluence',
        offerShown: 'AI',
        modalShownPrePostUpgrade: 'POST_UPGRADE'
    };
    const { clickedDismissModal: clickedDismissModal, clickedPrimaryCTAOnModal: clickedPrimaryCTAOnModal } = (0, $2v0M9.useAnalytics)();
    const handlePrimaryCTAClick = (e)=>{
        e?.preventDefault();
        clickedPrimaryCTAOnModal((0, $aamGC.CONFLUENCE_AFTER_STANDARD_UPGRADE_AI_MODAL), componentAttributes);
        handleClose();
        onInteractionComplete();
    };
    const handleDismissModal = (dismissalMethod)=>{
        clickedDismissModal((0, $aamGC.CONFLUENCE_AFTER_STANDARD_UPGRADE_AI_MODAL), {
            ...componentAttributes,
            dismissalMethod: dismissalMethod
        });
        handleClose();
        onInteractionComplete();
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $iJUOw.Modal), {
        height: "560px",
        logo: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceLogo), {
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }),
        title: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalTitle),
        subtitle: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalSubtitle),
        testId: "growth-pattern-library-modal",
        includeCloseButton: true,
        onClose: ()=>{
            handleDismissModal('closeButton');
        },
        sideContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $hWVhC.StandardOfferAIModalRightSide), {}),
        actions: /*#__PURE__*/ (0, $l998X.jsx)((0, $mSdG9.PrimaryAndSecondaryCTAActionsGroup), {
            onPrimaryCTAClick: handlePrimaryCTAClick,
            onSecondaryCTAClick: ()=>handleDismissModal('secondaryCTAButton'),
            primaryCTALabel: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalPrimaryCTA),
            secondaryCTALabel: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalSecondaryCTA)
        }),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1xVJk.EditionHighlightsLeftContent), {
                highlights: [
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))),
                        title: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalAIDraft)
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))),
                        title: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalAISummaries)
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iNP4c))),
                        title: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalAIContextualInfo)
                    }
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2v0M9.ScreenEvent), {
                name: "upgradeFreePoolTargetExperimentModal",
                attributes: componentAttributes
            })
        ]
    });
};


const $8f837e359ee131cc$export$ddc188f394bddd0c = ({ storageAdapter: storageAdapter })=>{
    const modalToShow = (0, $8kTwy.getPostUpgradeModalToShowForUpgradeFreePoolTargetExperiment)(storageAdapter, (0, $8kTwy.Product).Confluence);
    const cleanExperimentLocalStorageAttributes = ()=>{
        storageAdapter.removeItem((0, $8kTwy.STORAGE_KEYS).Confluence.first);
        storageAdapter.removeItem((0, $8kTwy.STORAGE_KEYS).Confluence.second);
    };
    switch(modalToShow){
        case (0, $8kTwy.UpgradeModalComponent).ConfluenceAfterStandardUpgradeAIModal:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $1ac42967dc0afcbf$export$38ccae318ce089cf), {
                onInteractionComplete: cleanExperimentLocalStorageAttributes
            });
        case (0, $8kTwy.UpgradeModalComponent).None:
        default:
            return null;
    }
};



var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $17wUi = parcelRequire("17wUi");


var $a7QKb = parcelRequire("a7QKb");

const $4f5a49218ecce596$export$4c71be9b3a5cb00 = ()=>{
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    // Audience is only eligible to see this experiment modal if they have upgraded to Confluence Standard edition
    if (!cloudId || !edition || edition !== (0, $euL71.ConfluenceEdition).STANDARD) return null;
    const confluenceStorageAdapter = {
        get: (key)=>{
            return (0, $17wUi.confluenceLocalStorageInstance).getItem(key);
        },
        set: (key, value)=>{
            (0, $17wUi.confluenceLocalStorageInstance).setItem(key, value);
        },
        removeItem: (key)=>{
            (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7QKb.ExperimentErrorBoundaryWrapper), {
        experimentKey: "twcg-206_confluence_upgrade_permanent_free",
        source: "UpgradeFreePoolExperimentModalPostUpgradeModalBaseComponent",
        cohort: "variation" // Post-upgrade users are always in the variation cohort
        ,
        additionalAttributes: {
            cloudId: cloudId,
            edition: edition
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8f837e359ee131cc$export$ddc188f394bddd0c), {
        storageAdapter: confluenceStorageAdapter
    }));
};
module.exports["UpgradeFreePoolExperimentModalPostUpgradeModalBaseComponent"] = $4f5a49218ecce596$export$4c71be9b3a5cb00;

});

parcelRegister("iJUOw", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8TTLA = parcelRequire("8TTLA");

var $8CZUH = parcelRequire("8CZUH");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $bWLcG = parcelRequire("bWLcG");


var $59OcG = parcelRequire("59OcG");


var $4gAvD = parcelRequire("4gAvD");


var $lJwTu = parcelRequire("lJwTu");

const $a38eaca20b61fcf5$var$hasSideContentContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    overflowY: 'auto',
    height: '100%',
    borderRadius: 'radius.small',
    [(0, $bWLcG.media).above.sm]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
    }
});
const $a38eaca20b61fcf5$var$baseContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $a38eaca20b61fcf5$var$stack = (0, $ecnYn.xcss)({
    height: '100%',
    padding: 'space.600',
    overflowY: 'auto'
});
const $a38eaca20b61fcf5$var$sideContainer = (0, $ecnYn.xcss)({
    display: 'none',
    [(0, $bWLcG.media).above.sm]: {
        backgroundColor: 'color.background.accent.gray.subtlest',
        display: 'flex',
        width: '100%',
        overflowY: 'auto'
    }
});
const $a38eaca20b61fcf5$var$leftSideContainer = (0, $ecnYn.xcss)({
    [(0, $bWLcG.media).above.sm]: {
        borderTopLeftRadius: 'radius.small',
        borderBottomLeftRadius: 'radius.small'
    }
});
const $a38eaca20b61fcf5$var$rightSideContainer = (0, $ecnYn.xcss)({
    [(0, $bWLcG.media).above.sm]: {
        borderTopRightRadius: 'radius.small',
        borderBottomRightRadius: 'radius.small'
    }
});
const $a38eaca20b61fcf5$var$closeButtonStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.200',
    right: 'space.200',
    zIndex: '1'
});
const $a38eaca20b61fcf5$export$2b77a92f1a5ad772 = ({ logo: logo, title: title, subtitle: subtitle, children: children, actions: actions, right: right, sideContent: sideContent, sideLocation: sideLocation = 'right', renderedInsideEntrypoint: renderedInsideEntrypoint, backgroundColor: backgroundColor, includeCloseButton: includeCloseButton = false, ...modalProps })=>{
    const hasSideContent = !!right || !!sideContent;
    const rightContent = right ?? (sideLocation === 'right' ? sideContent : undefined);
    const leftContent = !right && sideLocation === 'left' ? sideContent : undefined;
    const safeOnClose = typeof modalProps.onClose === 'function' ? modalProps.onClose : ()=>{};
    if (renderedInsideEntrypoint) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $a38eaca20b61fcf5$var$baseContainerStyles,
            hasSideContent ? $a38eaca20b61fcf5$var$hasSideContentContainerStyles : undefined
        ],
        backgroundColor: backgroundColor,
        style: {
            height: modalProps.height
        },
        children: [
            includeCloseButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $a38eaca20b61fcf5$var$closeButtonStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                    testId: "modal-close-button",
                    onClick: safeOnClose
                })
            }),
            !!leftContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $a38eaca20b61fcf5$var$sideContainer,
                    $a38eaca20b61fcf5$var$leftSideContainer
                ],
                children: leftContent
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                space: "space.400",
                xcss: $a38eaca20b61fcf5$var$stack,
                children: [
                    logo,
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $lJwTu.ModalTitle), {
                                children: title
                            }),
                            subtitle ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: "color.text.subtle",
                                size: "medium",
                                children: subtitle
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $59OcG.ModalBody), {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4gAvD.ModalFooter), {
                        children: actions
                    })
                ]
            }),
            !!rightContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $a38eaca20b61fcf5$var$sideContainer,
                    $a38eaca20b61fcf5$var$rightSideContainer
                ],
                children: rightContent
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
        width: hasSideContent ? 'x-large' : undefined,
        ...modalProps,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: [
                $a38eaca20b61fcf5$var$baseContainerStyles,
                hasSideContent ? $a38eaca20b61fcf5$var$hasSideContentContainerStyles : undefined
            ],
            backgroundColor: backgroundColor,
            children: [
                includeCloseButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $a38eaca20b61fcf5$var$closeButtonStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                        testId: "modal-close-button",
                        onClick: safeOnClose
                    })
                }),
                !!leftContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: [
                        $a38eaca20b61fcf5$var$sideContainer,
                        $a38eaca20b61fcf5$var$leftSideContainer
                    ],
                    children: leftContent
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                    space: "space.400",
                    xcss: $a38eaca20b61fcf5$var$stack,
                    children: [
                        logo,
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                            space: "space.200",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $lJwTu.ModalTitle), {
                                    children: title
                                }),
                                subtitle ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    color: "color.text.subtle",
                                    size: "medium",
                                    children: subtitle
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $59OcG.ModalBody), {
                            children: children
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4gAvD.ModalFooter), {
                            children: actions
                        })
                    ]
                }),
                !!rightContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: [
                        $a38eaca20b61fcf5$var$sideContainer,
                        $a38eaca20b61fcf5$var$rightSideContainer
                    ],
                    children: rightContent
                })
            ]
        })
    });
};
module.exports["Modal"] = $a38eaca20b61fcf5$export$2b77a92f1a5ad772;

});

parcelRegister("59OcG", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $crya1 = parcelRequire("crya1");


var $804cB = parcelRequire("804cB");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");

const $4494e4f87dd19321$var$container = (0, $ecnYn.xcss)({
    flex: '1 1 auto',
    overflowY: 'auto'
});
const $4494e4f87dd19321$export$cb540d8b0ef7906c = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $crya1.TouchScrollable), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
            space: "space.300",
            xcss: $4494e4f87dd19321$var$container,
            testId: testId,
            children: children
        })
    });
};
module.exports["ModalBody"] = $4494e4f87dd19321$export$cb540d8b0ef7906c;

});

parcelRegister("4gAvD", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $804cB = parcelRequire("804cB");


var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");

const $f0cb77ae0ad3836b$var$wrapStyles = (0, $ecnYn.xcss)({
    flexWrap: 'wrap-reverse'
});
const $f0cb77ae0ad3836b$export$519437715052e656 = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        alignInline: "end",
        testId: testId,
        space: "space.150",
        xcss: $f0cb77ae0ad3836b$var$wrapStyles,
        children: children
    });
};
module.exports["ModalFooter"] = $f0cb77ae0ad3836b$export$519437715052e656;

});

parcelRegister("lJwTu", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $804cB = parcelRequire("804cB");

const $b97fbf5d6df63832$export$b26fae16ba5468aa = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
        testId: testId,
        size: "large",
        id: titleId,
        children: children
    });
};
module.exports["ModalTitle"] = $b97fbf5d6df63832$export$b26fae16ba5468aa;

});


//# sourceMappingURL=base-component.01724bcf.js.map
